import { render, staticRenderFns } from "./CommButtons.vue?vue&type=template&id=6c27f7de&"
import script from "./CommButtons.vue?vue&type=script&lang=js&"
export * from "./CommButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports